import React from 'react'
import FormRow from '../../../../components/FormRow'
import FormCol from '../../../../components/FormCol'
import Typography from '@material-ui/core/Typography'
import {
  SimpleForm,
  NumberInput,
  BooleanInput,
  SelectInput,
  TextInput,
  CheckboxGroupInput,
  DateInput,
  Toolbar,
  SaveButton,
  useNotify,
  useRefresh,
  Create,
  required,
  useUpdate,
} from 'react-admin'
import StyledInput from '../../../../components/StyledInput'
import './common'
import {
  apartmentHasChoices,
  bathroomTypeChoices,
  depositChoices,
  floorChoices,
  furnitureChoices,
  houseForChoices,
  includedCostChoices,
  propertyTypeCoices,
} from './common'
import PropertyAddressInput from '../../../../components/PropertyAddressInput'
import { FindPropertyDialog } from '../../../../components/FindPropertyDialog'
import { Grid } from '@mui/material'

export const CreateProperty = (props) => {
  const refresh = useRefresh()
  const notify = useNotify()
  const [update] = useUpdate()
  const landlordId = props.record.landlord_id
  const leadPropertyId = props.record.id

  const onSuccess = (record) => {
    attachPropertyToLead(record.data)
  }

  const onFailure = (error) => {
    notify(`An Error occured while creating property  ${error}`, 'error', { smart_count: 1 }, true)
    refresh()
  }

  const attachPropertyToLead = (property) => {
    update(
      'leadProperties',
      leadPropertyId,
      { property_id: property.id },
      {},
      {
        onSuccess: () => {
          refresh()
          notify('Property Created!', 'info', { smart_count: 1 }, true)
        },
        onError: () => {
          notify(`Property not attached!`, { type: 'warning' })
        },
      },
    )
  }

  const CustomToolbar = (props) => {
    return (
      <Toolbar {...props}>
        <SaveButton onSuccess={onSuccess} onFailure={onFailure} submitOnEnter={false} />
      </Toolbar>
    )
  }

  const handleClickAttach = (property) => {
    attachPropertyToLead(property)
  }

  return (
    <Create {...props} record="" resource="properties">
      <SimpleForm warnWhenUnsavedChanges toolbar={<CustomToolbar />}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mb={4}>
          <FindPropertyDialog landlordId={landlordId} onClickAttach={handleClickAttach} />
        </Grid>
        <FormRow>
          <FormCol item xs={4}>
            <StyledInput component={NumberInput} source="owner_id" initialValue={landlordId} disabled />
          </FormCol>
          <FormCol item xs={4}>
            <StyledInput
              component={SelectInput}
              source="type"
              choices={propertyTypeCoices}
              initialValue=""
              validate={[required()]}
            />
          </FormCol>
          <FormCol item xs={4}>
            <StyledInput component={BooleanInput} source="pz" initialValue="true" disabled={true} />
          </FormCol>
        </FormRow>
        <Typography variant="h6" gutterBottom>
          Listing
        </Typography>
        <FormRow>
          <FormCol xs={12} sm={12} md={8} lg={8}>
            <StyledInput component={TextInput} source="listing.title" label="title" initialValue="" />
          </FormCol>
          <FormCol xs={12} sm={12} md={8} lg={8}>
            <StyledInput component={TextInput} multiline source="listing.description" label="description" initialValue="" />
          </FormCol>
        </FormRow>
        <Typography variant="h6" gutterBottom>
          Address
        </Typography>
        <FormRow>
          <FormCol xs={12} sm={12} md={8} lg={8} xl={8}>
            <PropertyAddressInput />
          </FormCol>
        </FormRow>
        <Typography variant="h6" gutterBottom>
          Details
        </Typography>
        <FormRow>
          <FormCol>
            <StyledInput
              component={SelectInput}
              source="details.bathoroms_type"
              choices={bathroomTypeChoices}
              label="bathoroms type"
              initialValue=""
            />
          </FormCol>
          <FormCol>
            <StyledInput component={SelectInput} choices={floorChoices} source="details.floor" label="floor" initialValue="" />
          </FormCol>
          <FormCol>
            <StyledInput
              component={NumberInput}
              source="details.number_of_bathrooms"
              label="number of bathrooms"
              initialValue=""
            />
          </FormCol>
          <FormCol>
            <StyledInput component={NumberInput} source="details.number_of_beds" label="number of beds" initialValue="" />
          </FormCol>
          <FormCol>
            <StyledInput component={NumberInput} source="details.size_sqm" label="size sqm" initialValue="" />
          </FormCol>
          <FormCol>
            <StyledInput component={NumberInput} source="details.total_bedrooms" label="total bedrooms" initialValue="" />
          </FormCol>
          <FormCol xs={12} sm={12} md={12} lg={12} xl={12}>
            <StyledInput
              component={CheckboxGroupInput}
              source="details.furnitures"
              label="Furnitures"
              row={true}
              choices={furnitureChoices}
              initialValue={[]}
            />
          </FormCol>
          <FormCol xs={12} sm={12} md={12} lg={12} xl={12}>
            <StyledInput
              component={CheckboxGroupInput}
              source="details.apartment_has"
              label="Apartment has"
              row={true}
              initialValue={[]}
              choices={apartmentHasChoices}
            />
          </FormCol>
        </FormRow>
        <Typography variant="h6" gutterBottom>
          Pricing
        </Typography>
        <FormRow>
          <FormCol>
            <StyledInput component={NumberInput} source="pricing.rent_price" label="rent price" />
          </FormCol>
          <FormCol>
            <StyledInput component={NumberInput} source="pricing.other_costs" label="other costs" />
          </FormCol>
          <FormCol>
            <StyledInput component={TextInput} source="pricing.currency" label="currency" disabled initialValue="EUR" />
          </FormCol>
        </FormRow>
        <Typography variant="h6" gutterBottom>
          Rules
        </Typography>
        <FormRow>
          <FormCol>
            <StyledInput component={DateInput} source="rules.availability_start_date" label="availability start date" />
          </FormCol>
          <FormCol>
            <StyledInput
              component={NumberInput}
              source="rules.months_notice_termination"
              label="months notice termination"
              initialValue={2}
            />
          </FormCol>
          <FormCol>
            <StyledInput component={NumberInput} source="rules.minimum_stay" label="minimum stay (months)" initialValue={3} />
          </FormCol>
          <FormCol>
            <StyledInput
              component={SelectInput}
              choices={houseForChoices}
              source="rules.house_for"
              label="house for"
              initialValue={'any'}
            />
          </FormCol>
          <FormCol>
            <StyledInput
              component={SelectInput}
              choices={depositChoices}
              source="rules.deposit"
              label="deposit"
              initialValue={2}
            />
          </FormCol>
          <FormCol>
            <StyledInput component={BooleanInput} source="rules.pets_allowed" label="pets allowed" />
          </FormCol>
          <FormCol xs={12} sm={12} md={12} lg={12} xl={12}>
            <StyledInput
              component={CheckboxGroupInput}
              source="rules.included_costs"
              label="Included cost"
              choices={includedCostChoices}
              initialValue={[]}
            />
          </FormCol>
        </FormRow>
      </SimpleForm>
    </Create>
  )
}
